import { Box, Button, Grid, Heading, HStack, Table, TableCaption, TableContainer, Tbody, Th, Td,Thead, Tr } from '@chakra-ui/react'
import React from 'react'
import { RiDeleteBin6Line, RiDeleteBin7Fill } from 'react-icons/ri'
import Sidebar from '../Sidebar'

const Users = () => {
  const users=[{
      _id:'123abc',
      name:'abhinav',
      role:'admin',
      subscription:{
        status:'active'
      },
      email:'123@gmail.com'
  }]
  const updateHandler=(userId)=>{
    console.log(userId);
  }
  const deleteBtnHandler=(userId)=>{
    console.log(userId);
  }
  return (    
    <Grid minH={'100vh'} templateColumns={['1fr','5fr 1fr']} >
        <Box p={['0','16']} overflowX='auto'>
            <Heading my='16' children='All Users' textAlign={['center','left']} />
            <TableContainer w={['100vw','full']}>
              <Table variant={'simple'} size='lg'>
                <TableCaption>
                  All available users in the database
                </TableCaption>
                <Thead>
                  <Tr>
                    <Th>Id</Th>
                    <Th>Name</Th>
                    <Th>Email</Th>
                    <Th>Role</Th>
                    <Th>Subsription</Th>
                    <Th isNumeric>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {
                    users.map(item=>(
                      <Row key={item._id} updateHandler={updateHandler} deleteBtnHandler={deleteBtnHandler} item={item}/>
                    ))
                  }
                </Tbody>
              </Table>
            </TableContainer>
        </Box>
        <Sidebar/>
    </Grid>   
  )
}

export default Users


function Row({item,updateHandler,deleteBtnHandler}){
  return(
    <Tr>
      <Td>#{item._id}</Td>
      <Td>{item.name}</Td>
      <Td>{item.email}</Td>
      <Td>{item.role}</Td>
      <Td>{item.subscription.status==='active' ? 'Active' : 'Not Active'}</Td>
      <Td isNumeric>
        <HStack justifyContent={'flex-end'}>
          <Button onClick={()=>{updateHandler(item._id)}} variant={'outline'} color='purple.500'>
            Change Role
          </Button>
          <Button onClick={()=>{deleteBtnHandler(item._id)}} color={'purple.600'} >
            <RiDeleteBin7Fill />
          </Button>
        </HStack>
      </Td>
    </Tr>
  )
}